import { render } from "./CurriculumEditTableRow.vue?vue&type=template&id=88983a4e&scoped=true&ts=true"
import script from "./CurriculumEditTableRow.vue?vue&type=script&lang=ts"
export * from "./CurriculumEditTableRow.vue?vue&type=script&lang=ts"

import "./CurriculumEditTableRow.vue?vue&type=style&index=0&id=88983a4e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88983a4e"]])

export default __exports__